var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwoTrainsLastBracket(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 365,
    viewBox: "0 0 26 365",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 344H0.5H3ZM23 359.5C24.3807 359.5 25.5 360.619 25.5 362C25.5 363.381 24.3807 364.5 23 364.5V359.5ZM5.5 258L5.5 344H0.5L0.5 258H5.5ZM5.5 344C5.5 348.965 5.93164 352.998 7.1559 355.727C7.74523 357.04 8.47217 357.943 9.33097 358.529C10.1775 359.106 11.3326 359.5 13 359.5V364.5C10.5007 364.5 8.32252 363.894 6.51278 362.659C4.71534 361.432 3.46311 359.71 2.5941 357.773C0.901696 354.002 0.5 349.035 0.5 344H5.5ZM13 359.5H23V364.5H13V359.5ZM0.5 218V37H5.5V218H0.5ZM0.5 37V0H5.5V37H0.5Z",
    fill: "#282D37"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwoTrainsLastBracket);
export default __webpack_public_path__ + "static/media/two_trains_last_bracket.f3a1cc180d14c155e81cf8e47c43b9d3.svg";
export { ForwardRef as ReactComponent };